import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const translations = {
  en: {
    nav: {
      about: "About",
      vision: "Vision",
      notify: "Get Notified",
    },
    hero: {
      badge: "Coming Soon",
      title: "CLOUD GM COIN",
      subtitle: "Digital · Decentralized · Peer to Peer",
      tagline:
        "A new digital asset crafted to power a future-ready payment and rewards ecosystem.",
      cta_email: "Enter your email",
      cta_button: "Notify Me",
      cta_subscribed: "You're on the list",
      cta_already: "Already subscribed",
      cta_error: "Please enter a valid email",
      cta_helper: "Be the first to hear when CGM goes live.",
    },
    status: {
      development: "Currently in active development",
      stay_tuned: "Stay tuned",
    },
    about: {
      kicker: "About Us",
      title: "Building a coin for the cloud generation",
      body:
        "CLOUD GM COIN is a digital, decentralized, peer-to-peer currency engineered as the native unit of value across the CloudGM ecosystem. We are obsessing over the fundamentals — security, transparency, and a frictionless user experience — to deliver a coin that simply works.",
      pillars: {
        digital: {
          title: "Digital First",
          text: "A purely digital token, designed for instant transfers across the cloud.",
        },
        decentralized: {
          title: "Decentralized",
          text: "No middlemen, no bottlenecks. Power stays with the holders.",
        },
        peer: {
          title: "Peer to Peer",
          text: "Send and receive value directly, anywhere, in seconds.",
        },
      },
    },
    vision: {
      kicker: "Our Vision",
      title: "The native currency of the CloudGM universe",
      body:
        "CGM is being built to serve as a primary payment method and rewards engine across the CloudGM and CloudGM Business platforms. Pay for services, unlock benefits, earn rewards, and tap into an economy designed to grow with its community.",
      tags: {
        payments: "Payments",
        rewards: "Rewards",
        ecosystem: "Ecosystem",
      },
      points: {
        cloudgm: {
          title: "CloudGM",
          text: "A primary payment option for everyday users — fast, simple, and built for the cloud era.",
        },
        cloudgm_business: {
          title: "CloudGM Business",
          text: "Power business transactions and customer rewards programs with a programmable digital asset.",
        },
        rewards: {
          title: "Rewards Engine",
          text: "Earn CGM by participating, transacting, and engaging across the ecosystem.",
        },
      },
      note: "Detailed coin specifications and tokenomics will be announced in due time.",
    },
    footer: {
      tagline: "Cloud GM Coin · The future of value, in the cloud.",
      rights: "All rights reserved.",
      built: "Coming soon",
    },
    lang: {
      switch_to_ar: "العربية",
      switch_to_en: "English",
    },
  },
  ar: {
    nav: {
      about: "من نحن",
      vision: "رؤيتنا",
      notify: "تنبيهي",
    },
    hero: {
      badge: "قريباً",
      title: "كلاود جي إم كوين",
      subtitle: "رقمية · لامركزية · ندّاً لندّ",
      tagline:
        "أصل رقمي جديد صُمم ليُشغّل منظومة دفع ومكافآت جاهزة للمستقبل.",
      cta_email: "أدخل بريدك الإلكتروني",
      cta_button: "نبّهني",
      cta_subscribed: "تم تسجيلك بنجاح",
      cta_already: "أنت مسجل بالفعل",
      cta_error: "يرجى إدخال بريد إلكتروني صحيح",
      cta_helper: "كن أول من يعرف بإطلاق العملة.",
    },
    status: {
      development: "العملة قيد التطوير الفعّال",
      stay_tuned: "انتظرونا قريباً",
    },
    about: {
      kicker: "من نحن",
      title: "نبني عملة لجيل السحابة",
      body:
        "كلاود جي إم كوين عملة رقمية لامركزية تعمل ندّاً لندّ، صُممت لتكون الوحدة الأساسية للقيمة داخل منظومة CloudGM. نهتم بالأساسيات: الأمان، الشفافية، وتجربة استخدام سلسة، لنقدّم عملة تعمل ببساطة وموثوقية.",
      pillars: {
        digital: {
          title: "رقمية بالكامل",
          text: "عملة رقمية مصمَّمة للتحويلات الفورية عبر السحابة.",
        },
        decentralized: {
          title: "لامركزية",
          text: "بلا وسطاء وبلا اختناقات. القوة تبقى للمستخدمين.",
        },
        peer: {
          title: "نداً لند",
          text: "أرسل واستقبل القيمة مباشرةً، في أي مكان وخلال ثوانٍ.",
        },
      },
    },
    vision: {
      kicker: "رؤيتنا",
      title: "العملة الأساسية لكون CloudGM",
      body:
        "نُطوّر CGM لتكون وسيلة دفع رئيسية ومحرّك مكافآت ضمن منصتي CloudGM وCloudGM Business. ادفع مقابل الخدمات، افتح المزايا، اكسب المكافآت، وكُن جزءاً من اقتصاد يكبر مع مجتمعه.",
      tags: {
        payments: "المدفوعات",
        rewards: "المكافآت",
        ecosystem: "المنظومة",
      },
      points: {
        cloudgm: {
          title: "CloudGM",
          text: "وسيلة دفع رئيسية للمستخدمين، سريعة وبسيطة ومصممة لعصر السحابة.",
        },
        cloudgm_business: {
          title: "CloudGM Business",
          text: "تشغيل المعاملات التجارية وبرامج مكافآت العملاء عبر أصل رقمي قابل للبرمجة.",
        },
        rewards: {
          title: "محرك المكافآت",
          text: "اكسب CGM من خلال المشاركة والتعاملات داخل المنظومة.",
        },
      },
      note: "سيتم الإعلان عن تفاصيل العملة وإعداداتها لاحقاً.",
    },
    footer: {
      tagline: "كلاود جي إم كوين · مستقبل القيمة، في السحابة.",
      rights: "جميع الحقوق محفوظة.",
      built: "قريباً",
    },
    lang: {
      switch_to_ar: "العربية",
      switch_to_en: "English",
    },
  },
};

const I18nContext = createContext({
  lang: "en",
  dir: "ltr",
  t: translations.en,
  toggle: () => {},
  setLang: () => {},
});

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "en";
    return localStorage.getItem("cgm_lang") || "en";
  });

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    localStorage.setItem("cgm_lang", lang);
  }, [lang]);

  const value = useMemo(
    () => ({
      lang,
      dir: lang === "ar" ? "rtl" : "ltr",
      t: translations[lang],
      setLang,
      toggle: () => setLang((p) => (p === "en" ? "ar" : "en")),
    }),
    [lang]
  );

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

export const useI18n = () => useContext(I18nContext);
